import { resolveApiUrl } from "~/utils/url/urlResolver";
import { getCsrfValue } from "~/common/utils/ApiHelper";

interface UpdateGuestCheckoutFormData {
  firstName: string;
  lastName: string;
  companyName: string;
  email: string;
  phone: string;
  line1: string;
  line2: string;
  zipCode: string;
  city: string;
  country: string;
  salutationCode?: string;
  titleCode?: string;
}

const URL = resolveApiUrl("/cart/submitGuestCheckoutForm");
export function submitGuestCheckoutForm(data: UpdateGuestCheckoutFormData) {
  return fetch(URL, {
    method: "POST",
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    redirect: "follow",
    body: JSON.stringify(data),
  });
}
